import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "md:tw-grid md:tw-grid-cols-3 md:tw-gap-x-6 md:tw-gap-y-12" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tw-bg-primary tw-text-mainbg1 tw-text-lg tw-font-medium tw-text-center tw-py-1" }
const _hoisted_4 = { class: "tw-aspect-video tw-w-full" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
      return (_openBlock(), _createElementBlock("li", {
        key: game.id
      }, [
        _createElementVNode("div", {
          onClick: ($event: any) => (_ctx.$emit('selectgame', game)),
          class: "tw-cursor-pointer hover:tw-outline hover:tw-outline-2 hover:tw-outline-primary hover:tw-outline-offset-2"
        }, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(game.name), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.$filters.buildPath('/media/images/game_small_thumbs/' + game.id + '.png'),
              class: "tw-w-full tw-h-full tw-object-cover"
            }, null, 8, _hoisted_5)
          ])
        ], 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}